/**
 * Tipos de períodos de descanso.
 * Const (não `enum`) para permitir testes unitários com Node strip-types.
 */
export const TipoPeriodoDescanso = {
  Ferias: 0,
  FolgaNatalicia: 1,
  AbonoTrabalhado: 2,
  AbonoEspecial: 3,
  LicencaPremio: 4,
  LicencaOutros: 5,
  Afastamento: 6,
} as const;

export type TipoPeriodoDescanso =
  (typeof TipoPeriodoDescanso)[keyof typeof TipoPeriodoDescanso];
